import axios from "axios";

const base_API_IBGE_URL = process.env.REACT_APP_API_IBGE_URL || "";

const apiIBGE = axios.create({
  baseURL: base_API_IBGE_URL,
});

export default apiIBGE;
